import React, { useState, useEffect } from 'react';
import '../../../../pages/client/client_assets/css/Surveys.css';
import '../../../../pages/client/client_assets/css/responsive.css';
// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import enter_Arrow from '../../../../pages/client/client_assets/img/presskey.svg';
import preview_img from '../../../../pages/client/client_assets/img/preview.svg';
import share_img from '../../../../pages/client/client_assets/img/share.svg';
import add_img from '../../../../pages/client/client_assets/img/plus.svg';
import { SmileOutlined } from '@ant-design/icons';
import {  notification } from 'antd';
import { Breadcrumb } from 'antd';

import { useLocation, Link } from 'react-router-dom';
import EmployeeResult from './PartnerResult';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const fetchWelcomeAndEndQuestions = async () => 
    {
    try {
      const response = await fetch('https://api.skepper.in/get_all_pquestions.php');
      const data = await response.json();
      return data.questions.filter((question) => question.q_type === 'welcome' || question.q_type === 'end');
    } catch (error) {
      console.error('Error fetching questions:', error);
      return [];
    }
  };

const PartnerForms = () => {

    const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    // Fetch the user's logo from the backend
    fetch('https://api.skepper.in/get_logo.php', {
      method: 'GET',
      credentials: 'include',  // Make sure to send session cookies
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setLogoUrl(data.logo_url);  // Set the fetched logo URL
        } else {
          console.error('Error fetching logo:', data.message);
        }
      })
      .catch(error => console.error('Error fetching logo:', error));
  }, []);


    const [currentStep, setCurrentStep] = useState(0);
    const [showError, setShowError] = useState('');
    const [showStart, setShowStart] = useState(true);
    const [successMsg, setSuccessMsg] = useState(false);

    const [showOverlay, setOverlay] = useState(false);
    // const [closeOverlay, setCloseOverlay] = useState();

    const [formData, setFormData] = useState({});
    const [questions, setQuestions] = useState([]);

    const [welcomeEndQuestions, setWelcomeEndQuestions] = useState([]);

    useEffect(() => {
        fetchWelcomeAndEndQuestions().then((questions) => {
          setWelcomeEndQuestions(questions);
        });
      }, []);


      const alphabetOrder = ["A","B","C","D","E"]
  useEffect(() => {

    // Fetch questions from the PHP API
    fetch('https://api.skepper.in/get_all_pquestions.php')
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          const processedQuestions = data.questions.map((question) => {
            const randomAnswerKey = `answerKey_${Math.random().toString(36).substring(7)}`;

            if (question.q_type === 'choice') {
              return {
                id: question.id,
                questionText: question.question,
                answerKey: randomAnswerKey,
                options: [
                  question.option1,
                  question.option2,
                  question.option3,
                  question.option4,
                ],
                inputType: 'button',
              };
            } else if (question.q_type === 'key-question') {
              return {
                id: question.id,
                questionText: question.question,
                answerKey: randomAnswerKey,
                inputType: 'text',
              };
            }
            return null;
          }).filter(Boolean); 

          setQuestions(processedQuestions);

          const initialFormData = processedQuestions.reduce((acc, question) => {
            acc[question.answerKey] = Array.isArray(question.options) ? [] : '';
            return acc;
          }, {});
          setFormData(initialFormData);
        } else {
          console.error('Failed to fetch questions:', data.message);
        }
      })
      .catch((error) => {
        console.error('Error fetching questions:', error);
      });
  }, []);


//   const handleInputChange = (e, answerKey) => {
//     const { value } = e.target;
//     setFormData((prevState) => ({
//         ...prevState,
//         [answerKey]: value,
//     }));
//     if (showError && value.trim() !== "") {
//         setShowError('');
//     }
// };


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                event.preventDefault();
                if (showStart) {
                    setShowStart(false);
                } else {
                    nextStep(formData[questions[currentStep].answerKey]);
                }
            }
        };
    
        window.addEventListener("keydown", handleKeyDown);
    
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [showStart, currentStep, formData, questions]); 
    


    // const handleOptionClick = (answerKey, option) => {
    //     setFormData(prevState => ({
    //         ...prevState,
    //         [answerKey]: prevState[answerKey]
    //             ? prevState[answerKey].includes(option)
    //                 ? prevState[answerKey].filter(item => item !== option)
    //                 : [...prevState[answerKey], option]
    //             : [option] 
    //     }));
    // };

    const handleOptionClick = (answerKey, option) => {
        setFormData(prevState => ({
            ...prevState,
            [answerKey]: option
        }));
    };
    const nextStep = (currentInputValue) => {
        if ((typeof currentInputValue === 'string' && currentInputValue.trim() === "") ||
            (Array.isArray(currentInputValue) && currentInputValue.length === 0)) {
            setShowError('Please fill this in');
        } else {
            setShowError('');
            if (currentStep < questions.length - 1) {
                setCurrentStep(currentStep + 1);
            } else {
                handleSubmit();
            }
        }
    }

    const handleSubmit = () => {
        console.log(formData);
        setSuccessMsg('Form submitted. Check the console for data.');
    };

    const [showCopyLink, setShowCopyLink] = useState(false);
            const [copyFormLink, setCopyFormLink] = useState('');
            
            const fetchFormLink = async () => {
                try {
                    const response = await fetch("https://api.skepper.in/get_pform_link.php", {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        credentials: "include",
                    });
            
                    const data = await response.json();
            
                    if (data.success && data.pform_link) {
                        const generatedLink = `https://brewyourbrand.in/${data.pform_link}`;
                        setCopyFormLink(generatedLink);
                        setShowCopyLink(true);
            
                        // Copy the link to the clipboard
                        await navigator.clipboard.writeText(generatedLink);
                        console.log('Link copied to clipboard:', generatedLink);
                    } else {
                        console.error("Failed to fetch the link:", data.message);
                    }
                } catch (error) {
                    console.error("Error in fetchFormLink function:", error);
                }
            };
            
            const copyLink = () => {
                fetchFormLink(); // Fetch link only when Share is clicked
            };
    
    
  

        // file file and drag 

        const [selectedImage, setSelectedImage] = useState(false);

        const getFile = (event) => {
                        console.log("getFile() triggered");  // 🔎 Check if function is called
                        const file = event.target.files[0];
                        if (file) {
                            console.log("File detected:", file.name);  // 🔎 Confirm file data
                            const formData = new FormData();
                            formData.append('logo', file);
                    
                            fetch('https://api.skepper.in/upload_logo.php', {
                                method: 'POST',
                                body: formData,
                                credentials: 'include',  
                            })
                            .then(response => response.json())
                            .then(data => {
                                console.log("Server response:", data);  // 🔎 Check server response
                                if (data.success) {
                                    setSelectedImage(URL.createObjectURL(file));
                                    toast.success(`Logo updated successfully!`);
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 3000);
                                    
                                } else {
                                    toast.error(data.message || "Error updating logo.");
                                }
                            })
                            .catch(error => {
                                console.error('Error uploading logo:', error);
                                toast.error("Error updating logo.");
                            });
                        } else {
                            console.log("No file selected");  // 🔎 Check if no file was uploaded
                        }
                    };
        

        // const handleDragOver = (event) => {
        //     event.preventDefault(); // Prevent default behavior (prevent file from being opened)
        // };
    
        // const handleDrop = (event) => {
        //     event.preventDefault();
        //     const file = event.dataTransfer.files[0]; // Access files from the dataTransfer object
        //     if (file) {
        //         setSelectedImage(URL.createObjectURL(file));
        //     }
        // };
        
        // file upload modal
        const [modalShow, setModalShow] = React.useState(false);

        function MyVerticallyCenteredModal(props) {
            return (
              <Modal
                {...props}
                size="lg"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='upload_logo_modal'
              >
                <Modal.Header closeButton className='border-0'>
             
                </Modal.Header>
                <Modal.Body>
                <div className='position-relative'>
                <input 
    type="file" 
    onChange={getFile} 
    accept="image/*" // Accept only image files
    style={{ width: '100%' }} 
/>

                        <div className='upload_txt'>
                            <p className='mb-0'>Upload or drop an image right here</p>
                            <p className="file-types mb-0">JPG, PNG, or GIF. Up to 4MB.</p>
                            
                        </div>
                        {selectedImage && (
                            <div className='preview_img'>
                                <img src={selectedImage} alt="Selected" style={{ width: '100%', marginTop: '10px' }} />
                            </div>
                        )}

                        <div className='update text-center'>
                            <button onClick={updateHandle}>Update</button>
                        </div>
                    </div>
                </Modal.Body>
              </Modal>
            );
          }

                          const [surveyTab, setSurveyTab] = useState(true)
                        //  const [resultTab, setResultTab] = useState(false)
                         
                         const [activeTab, setActiveTab] = useState('create')
                         const createHandle = ()=>{
                            setSurveyTab(true)
                            // setResultTab(false)
                            setActiveTab('create')
                         }
                
                         const resultHandle = ()=>{
                        //    setResultTab(true)
                           setSurveyTab(false)
                           setActiveTab('result')
                
                       }
       
                    //    const handleTabChange = (tab) => {
                    //        setActiveTab(tab);  // Set the active tab state
                    //    };
       
        //   hide copy link when preview icon clicked
        // const [showPreview, setShowPreview] = useState()

        // const hideCopyLink = ()=>{
        //     setShowPreview(false)
        // }

              // adding overlay to the page
              const addBg = ()=>{
                setOverlay(true)
                setShowCopyLink(false)
                setFullForm('full_form')

            }

            const closePopOverlay = () =>{
                setOverlay(false)
                setFullForm(false)
            }

            // add new class for form
            const [fullForm, setFullForm] = useState()

            // Toast message to link copied
            const [api, contextHolder] = notification.useNotification();
            
            const openNotification = () => {
                api.open({
                    message: 'Your form link has been copied',
                //   description:
                //     'Your form link has been copied',
                  icon: (
                    <SmileOutlined
                      style={{
                        color: '#108ee9',
                      }}
                    />
                  ),
                });
              };

            // copy link clipboard text

            //const [copyFormLink, setCopyFormLink] = useState('https://form.typeform.com/to/orl4Qfv7');

            const clickText = async ()=>
            {
                        try{
                                await window.navigator.clipboard.writeText(copyFormLink)
                                openNotification()
                        }

                        catch(error){
                            console.error('Unable to copy the clipboard', error)
                        }
            }

            const [successMessage, setSuccessMessage] = useState(false)

            const updateHandle=()=>{
                setSuccessMessage(true)
            }

            // const [customerForm,setCustomerForm] = useState(false)
            // const [employeeForm,setEmployeeForm] = useState(false)
            // const [partnerForm,setPartnerForm] = useState(false)
            // const [investorForm,setInvestorForm] = useState(false)

            let location = useLocation();

            useEffect(()=>{

                if(location.pathname==="/client/customer-form"){
                        // console.log("Yes it is customer detail");
                        // setCustomerForm(<CustomerForm/>)
                        // setCustomerForm(true)

                }
                else if(location.pathname==="/client/employee-form"){
                    // console.log("Yes it is employee detail");
                    // setEmployeeForm(<EmployeeForm/>)
                    // setEmployeeForm(true)
                    // setCustomerForm(false)

                }
                else if(location.pathname==="/client/partner-form"){
                    // console.log("Yes it is partner detail");
                    // setPartnerForm(<PartnerForm/>)
                    // setPartnerForm(true)

                }
                else if(location.pathname==="/client/investor-form"){
                    // console.log("Yes it is investor detail");
                    // setInvestorForm(<InvestorForm/>)
                    // setInvestorForm(true)
                    // setCustomerForm(false)

                }
                
            },[]);

            const handleInputChange1 = (e, answerKey) => {
                const { value } = e.target;
            
                // Update the state for the specific question
                setFormData(prevState => ({
                    ...prevState,
                    [answerKey]: value, // Use the answerKey to update the specific question's value
                }));
            };

  return (
    <>
    <div className='container-fluid survey_container'>

<Breadcrumb
    itemRender={(item, _, routes) => {
        const last = routes.indexOf(item) === routes.length - 1;
        return last ? (
            <span>{item.title}</span>
        ) : (
            <Link to={item.path}>{item.title}</Link>
        );
    }}
    items={[
        {
            title: 'Surveys',
            path: '/client/surveys', // Adjust the path as necessary
        },
        {
            title: 'Partner',
        },
    ]}
/>
            <div className='tabs_border survey_tabs'>
                    <button onClick={createHandle} className={activeTab==='create' ? 'tab_active' :''}>
                        <p>Create</p>
                     </button>
                    <button onClick={resultHandle} className={activeTab==='result' ? 'tab_active' :''}>
                        <p>Result</p>
                    </button>
            </div>

         {contextHolder}


                {
                    surveyTab ? (
<div className='form'>
        {
                showOverlay &&
                        <div className='overlay'>
                            <div className='' onClick={closePopOverlay}>
                                <p > <i className="fa fa-solid fa-xmark text-black"></i></p>
                                </div>
                        </div>
        }
        {
            showCopyLink ? ( 
            <div className='copy_link_wrapper'>
                <div className='copy_link'>
                        <input type="text" value={copyFormLink}  onChange={(e)=>setCopyFormLink(e.target.value)}/>
                        <button onClick={clickText}><i className="fa fa-solid fa-link"></i> Copy</button>
                </div>    
            </div>

            ) : ("")
        }
        <div className={`form_wrapper ${fullForm ? "form_style partner_form" : ""}`}>
            <div className='row'>
                <div className="log_upload">
                    <img src={logoUrl || 'https://api.skepper.in/uploads/6794d4bd5207a1.41619389.png'} alt="User Logo" className="d_logo" />
                </div>
                <div className='parent px-0 mt-3'>
                  
                <div className="form_sec">
                {
                 showOverlay &&
                    <div className='form_style_overlay'>
                        <div className='text-center' onClick={closePopOverlay}>
                            <p > 
                            <img src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path fill='%23ffffff' d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z'/></svg>" alt="close"  style={{width:"19px"}}/>
                            </p>
                            </div>
                    </div>
              }

                    {
                    showStart ? (
                        <div className="start">
                          <h3>{welcomeEndQuestions.length ? welcomeEndQuestions.find((question) => question.q_type === 'welcome')?.q_title : 'We\'re Here to Help!'}</h3>
                          <p>{welcomeEndQuestions.length ? welcomeEndQuestions.find((question) => question.q_type === 'welcome')?.q_desc : 'Have questions or need assistance? Get in touch with us today.'}</p>
                          <div className="start_btn">
                            <button onClick={() => setShowStart(false)}>Start</button>
                            <p>Press Enter <img src={enter_Arrow} alt="Enter Arrow" /></p>
                          </div>
                        </div>
                      ) : successMsg ? (
                        <div className="success-message">
                          <h4>
                            {welcomeEndQuestions.length ? welcomeEndQuestions.find((question) => question.q_type === 'end')?.q_title : '🎉 Thank You for Prebooking!'}
                          </h4>
                          <p>
                            {welcomeEndQuestions.length ? welcomeEndQuestions.find((question) => question.q_type === 'end')?.q_desc :
                              'Our team will reach out to you shortly with further details. For questions, reach out at <a href="mailto:support@brewyourbrand.in">support@brewyourbrand.in</a> or call <a href="tel:+918150002200">+91 8150 00 22 00</a>'}
                          </p>
                        </div>
                      )
                    :
                    ((

                        <div className='question_form'>
    <form onSubmit={handleSubmit}>
        {questions.map((question, index) => (
            currentStep === index && (
                <div key={question.id}>
                    <label>{index+1}. {question.questionText}

                        
                    </label>
                    {question.inputType === 'button' ? 
                        question.options.map((option,optionIndex) => (
                            <div className='check_form' key={option}>
                                <div 
                                    className={`button-option ${formData[question.answerKey]?.includes(option) ? 'active' : ''}`}
                                    onClick={() => handleOptionClick(question.answerKey, option)}
                                >
                                      <span className='alphabet_border'> {alphabetOrder[optionIndex]}</span>  {option.slice(0)}
                                </div>
                            </div>
                        )) : (
                        <div className='text_form'>
                            <input
                                type={question.inputType}
                                value={formData[question.answerKey] || ''}
                                onChange={(e) => handleInputChange1(e, question.answerKey)} // Pass the event and answerKey
                                name={question.answerKey}
                                required // Make the field mandatory
                            />
                        </div>
                    )}
                    <div className='next_prev'>
                        {index > 0 && (
                            <button type="button" onClick={() => setCurrentStep(currentStep - 1)}>Previous</button>
                        )}
                        {index < questions.length - 1 ? (
                            <>
                                <button 
                                    type="button" 
                                    onClick={() => nextStep(formData[questions[currentStep].answerKey])}
                                    disabled={!formData[questions[currentStep].answerKey]} // Disable next if field is empty
                                >
                                    Next
                                </button>
                            </>
                        ) : (
                            <button type="submit">Submit</button>
                        )}
                    </div>
                    {showError && <p className="error">{showError}</p>}
                </div>
            )
        ))}
    </form>
</div>

                    )
                    )
                    }
                </div>
                <div className='edit_prev'>
                    <div className='right_wrapper'>
                            <div className='previous' onClick={addBg}>
                                <p>Preview</p>
                                 <img src={preview_img} alt="" />
                            </div>
                            <hr />
                            <div className='share' onClick={copyLink}>
                                <p>Share</p>
                                <img src={share_img} alt="" />

                            </div>
                    </div>

                    <div className='edit_wrapper'>
                        <div className='edit_sec'>
                            <h5 className='mb-0'>Edit Preferences</h5>
                         </div>

                        <div className='brand_wrapper' onClick={() => setModalShow(true)}>
                            <p>Brand Logo</p>
                            <img src={add_img} alt="" />
                        </div>
                        {
                            successMessage && 
                            <div className="upload_msg">
                            <p>updated successfully</p>
                                </div>
                        }
                             
                    </div>
                </div>
                </div>
            </div>
        </div>
        </div>
                    ) :

                    (
                        <div className=''>
                               <EmployeeResult/>
                         </div> 
                    )
                }

        

             
            <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

    </div>
    <ToastContainer />
    </>
  )
}

export default PartnerForms
